import {
    AfterViewInit,
    Component,
    ElementRef,
    HostBinding,
    HostListener,
    inject,
    Input,
    ViewChild,
} from '@angular/core';
import { IAppMenu, INavMenu } from '../../../../interfaces/IAppRoutes';

import { LayoutService } from './../../services/layout.service';
import { PreviousRouteService } from '../../services/previous-route.service';
import { AppUpdateService } from '../../services/app-update.service';

@Component({
    selector: 'pf-app-layout',
    templateUrl: './app-layout.component.html',
    styleUrls: ['./app-layout.component.scss'],
    standalone: false,
})
export class AppLayoutComponent implements AfterViewInit {
    _previousRouteService = inject(PreviousRouteService);
    _appUpdateService = inject(AppUpdateService);
    layoutService = inject(LayoutService);

    @ViewChild('layoutContainer', { static: true, read: ElementRef })
    layoutContainer!: ElementRef<HTMLElement>;
    @Input() navigation: IAppMenu[] = [];

    @HostBinding('class.header-hidden')
    get headerHidden() {
        return this.layoutService.headerHidden;
    }

    ngAfterViewInit(): void {
        this.layoutService.scrollContainer = this.layoutContainer.nativeElement;
        this.layoutService.scrollToRefreshContainer =
            this.layoutContainer.nativeElement;
    }

    /**
     * Pull-to-refresh watches the outer layout container, but most screens
     * scroll in inner containers — so its "at top" check is always true and a
     * scroll flick can trigger a refresh. On each touch, find the scroll parent
     * of the touched element and report whether it is at its top; the layout
     * service gates pull-to-refresh on that.
     */
    @HostListener('touchstart', ['$event'])
    onTouchStartCapture(event: TouchEvent): void {
        const scroller =
            this.findScrollableAncestor(event.target as HTMLElement | null) ??
            this.layoutContainer.nativeElement;
        this.layoutService.setActiveScrollAtTop(scroller.scrollTop <= 0);
    }

    private findScrollableAncestor(
        el: HTMLElement | null
    ): HTMLElement | null {
        const stop = this.layoutContainer.nativeElement;
        let node = el;
        while (node && node !== stop) {
            const overflowY = getComputedStyle(node).overflowY;
            if (
                (overflowY === 'auto' || overflowY === 'scroll') &&
                node.scrollHeight > node.clientHeight
            ) {
                return node;
            }
            node = node.parentElement;
        }
        return null;
    }

    expanderClickHandler() {
        this.layoutService.isCollapsed = !this.layoutService.isCollapsed;
    }

    navigationTrackByFn(_: number, menu: INavMenu) {
        return menu.displayName;
    }
}
